/**
 * **e-GDS**
 *
 * @exports bs_265
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_265
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      const aux = ((document.querySelector('.LangCurrency') || {}).textContent || '').trim().toLowerCase();
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_265
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates

    const startDate = thn.parseUrlParameter('arrivaldate');
    const endDate = thn.parseUrlParameter('departuredate');
    const dateBegin = (document.querySelector('.DateFrom') || {}).value;
    const dateEnd = (document.querySelector('.DateTo') || {}).value;
    if (startDate.length === 8 && endDate.length === 8) {
      widgetData.dateBegin = `${startDate.slice(0, 4)}/${startDate.slice(4, 6)}/${startDate.slice(6, 8)}`;
      widgetData.dateEnd = `${endDate.slice(0, 4)}/${endDate.slice(4, 6)}/${endDate.slice(6, 8)}`;
    } else if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }

    // Guests, Adults & Children
    widgetData.adults = parseInt((document.querySelector('.qtyAdults') || {}).value, 10) || 1;
    widgetData.children = parseInt((document.querySelector('.qtyChildrens') || {}).value, 10) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms
    const nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    const prices = [...document.querySelectorAll('.HotelLink span')].map((el) => thn.parseNumber(el.textContent));
    const currency = ((document.querySelector('span[id$="Currency"]') || {}).textContent || '').replace(/\./g, '') || 'USD';

    if (prices.length) {
      widgetData.price = ((Math.min(...prices) / nights) * 100) / 100;
      widgetData.currency = currency;
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_265
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    // Dates
    const dateBegin = ((document.querySelector('td:nth-child(6)') || {}).textContent || '').trim().slice(-10).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1')
        || ((document.querySelector('.start') || {}).textContent || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
    const dateEnd = ((document.querySelector('td:nth-child(7)') || {}).textContent || '').trim().slice(-10).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1')
        || ((document.querySelector('.end') || {}).textContent || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');

    widgetData.dateBegin = dateBegin;
    widgetData.dateEnd = dateEnd;

    // Booking ID
    widgetData.bookingId = thn.parseUrlParameter('ReserveID') || (document.querySelector('span[id$="ReserveNumberValue"]') || {}).textContent;

    // Price & Currency
    widgetData.price = thn.parseNumber((document.querySelector('span[id$="TotalByHotel"]') || {}).textContent);
    widgetData.currency = ((document.querySelector('span[id$="Currency"]') || {}).textContent || '').replace(/\./g, '');

    return widgetData;
  };

  return engine;

}

export { factory };
